export default __webpack_public_path__ + "static/media/PREMATURE-EJACULATION.80939290.png";